import { useEffect, useState } from "react";
import { Copy, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { waLink } from "@/lib/solicitudes";
import { copyText } from "@/lib/utils";

const Msg = ({ label, phone, value, onChange, testid }) => {
  const link = waLink(phone, value);
  const copy = async () => ((await copyText(value)) ? toast.success("Mensaje copiado") : toast.error("No se pudo copiar"));
  return (
    <div className="space-y-1.5">
      <p className="text-xs font-semibold c-text-2">{label}</p>
      <textarea data-testid={`${testid}-text`} rows={4} className="c-input text-sm" value={value} onChange={(e) => onChange(e.target.value)} />
      {link ? (
        <a data-testid={`${testid}-wa`} href={link} target="_blank" rel="noreferrer" className="c-btn-primary w-full py-2.5 flex items-center justify-center gap-2 text-sm"><MessageCircle className="w-4 h-4" /> Abrir WhatsApp</a>
      ) : (
        <button data-testid={`${testid}-copy`} onClick={copy} className="w-full py-2.5 rounded-xl border c-line flex items-center justify-center gap-2 text-sm font-semibold"><Copy className="w-4 h-4" /> Sin teléfono · Copiar mensaje</button>
      )}
    </div>
  );
};

export const PresentationCard = ({ p, solicitante }) => {
  const [a, setA] = useState(p.mensaje_contacto);
  const [b, setB] = useState(p.mensaje_solicitante);
  useEffect(() => { setA(p.mensaje_contacto); setB(p.mensaje_solicitante); }, [p]);
  return (
    <div data-testid="presentation-card" className="c-card p-4 space-y-4">
      <p className="font-semibold">Hacer la presentación</p>
      <Msg label={`1. A tu contacto, ${p.contacto_nombre}`} phone={p.contacto_telefono} value={a} onChange={setA} testid="presentation-contact" />
      <Msg label={`2. A ${solicitante}`} phone={p.solicitante_telefono} value={b} onChange={setB} testid="presentation-requester" />
    </div>
  );
};
